import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useUser } from '../UserContext';

  const Home = () => {
  const { setUserInfo } = useUser();
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const navigate = useNavigate();
  const url = 'https://apitstripas.wensystem.com.br';
  const alias = 'TSTRIPAS';

  const handleLogin = async (e) => {
    e.preventDefault();
    
    try {
      const upperUsername = username.toUpperCase();
    
      if (!upperUsername || !password) {
        alert('Por favor, preencha todos os campos.');
        return;
      }
    
      // Codifica o par username:password em Base64
      const credentials = btoa(`${alias};${upperUsername}:${password}`);
    
      const response = await fetch(url + '/login/v1', {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'empresa': alias,
          'Authorization': `Basic ${credentials}`, // Insere o cabeçalho Authorization
        }
      });
    
      if (response.ok) {
        // Leia o JSON da resposta apenas uma vez
        const data = await response.json();
        //console.log('Dados recebidos:', data);
    
        // Verifica a estrutura do dado retornado
        if (Array.isArray(data) && data.length > 0 && data[0].login) {
          if (data[0].login === "Login realizado com sucesso!") {
            setUserInfo({
              username: data[0].nome,
              company: data[0].empresa,
              id: data[0].venId,
              dpc_id: data[0].dpcId,
              venLogin: data[0].venLogin,
              venSenha: data[0].venSenha,
              pdc_id: data[0].pdcId,
              relatorio: data[0].relatorio,
              qtdTipoTripas: data[0].qtdTipoTripas,
                url : url,
                alias : alias,
                urlEmail :'https://backend.wensystem.com.br/webhook/apie-mail-almoxarifado-tstripas',
            });
            navigate('/menu');
          } else {
            alert('Login falhou. Por favor, verifique suas credenciais.');
          }
        } else {
          console.error('Estrutura de resposta inesperada:', data);
          alert('Login ou senha inexistente. Por favor, tente novamente.');
        }
    
      } else {
        // Para respostas com erro, capture o texto (não como JSON)
        //const errorText = await response.text();
        //console.error('Erro no login:', response.status, errorText);
        alert('Falha ao fazer login. Por favor, tente novamente.');
      }
    
    } catch (error) {
      //onsole.error('Erro ao fazer login:', error);
      alert('Ocorreu um erro ao fazer login. Por favor, tente novamente.');
    }    
  };

  return (
    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', marginTop: '50px' }}>
      <img src="https://www.tstripas.com.br/wp-content/uploads/2024/08/TS-TRIPAS-1-Logos.png" alt="Logo" style={{ marginBottom: '20px' }} />
      <h1 style={{ textAlign: 'center' }}>LOGIN</h1>
      <form onSubmit={handleLogin} style={{ display: 'flex', flexDirection: 'column', width: '300px' }}>
        <input
          type="text"
          placeholder="Nome do Usuário"
          value={username}
          autoComplete='username'
          onChange={(e) => setUsername(e.target.value.toUpperCase())}
          required
          style={inputStyle}
        />
        <input
          type="password"
          placeholder="Senha"
          value={password}
          autoComplete='current-password'
          onChange={(e) => setPassword(e.target.value.toUpperCase())}
          required
          style={inputStyle}
        />
        <button type="submit" style={buttonStyle}>Login</button>
      </form>
    </div>
  );
};

const inputStyle = {
  padding: '10px',
  margin: '10px 0',
  border: '1px solid #ccc',
  borderRadius: '4px',
};

const buttonStyle = {
  padding: '10px',
  backgroundColor: '#4CAF50',
  color: 'white',
  border: 'none',
  borderRadius: '4px',
  cursor: 'pointer',
};

export default Home;